import {get} from "./HttpClient"
import {API_GET_SEARCHED_AIRPORTS, API_GET_SEARCHED_AIRPORTS_CODES} from "./ApisRoutes";

export const GetAirportsService = (search, locale) => {
    const airportsApi = API_GET_SEARCHED_AIRPORTS + "?Search=" + search + "&Locale=" + locale;
    return new Promise((resolve, reject) => {
        get(airportsApi).then(response => {
            resolve(response?.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

export const GetAirportsCodesService = (search, locale, IataOrName = 'iata') => {
    const airportsApi = `${API_GET_SEARCHED_AIRPORTS_CODES}?Search=${search}&Locale=${locale}&IataOrName=${IataOrName}`;
    console.log({airportsApi});
    return new Promise((resolve, reject) => {
        get(airportsApi)
            .then(response => {
                resolve(response?.data);
            })
            .catch(error => {
                console.log(error);
                reject(error);
            });
    });
};
